"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openSansSemiBold = void 0;
exports.openSansSemiBold = {
    familyName: "Open Sans",
    weight: "600",
    style: "normal",
    ttfName: "OpenSans-SemiBold",
    ttfFile: "open-sans-semi-bold.ttf",
    woff2File: "open-sans-semi-bold.woff2",
};
